<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.1727 12.0001L9.34375 9.17208L10.7577 7.75708L15.0007 12.0001L10.7577 16.2431L9.34375 14.8281L12.1727 12.0001Z"
      fill="currentColor"
    />
  </svg>
</template>
